import { Component, Element, h, Prop, State } from '@stencil/core'
import { marked as Marked } from 'marked'

function escapeCode(code: string) {
  return code.trim().replace(/</g, '&lt;').replace(/>/g, '&gt;')
}

Marked.use({
  renderer: {
    code(code: string, lang: string) {
      return `<preview-code language='${lang}'>${escapeCode(code)}</preview-code>`
    },
    codespan(code: string) {
      return `<preview-code inline>${escapeCode(code)}</preview-code>`
    },
  },
})

function unindent(src: string) {
  const [, { length }] = /^([ \t]*)\S/m.exec(src)
  // eslint-disable-next-line
  return src.replace(new RegExp(`^[ \t]{${length}}`, 'gm'), '').trim()
}

@Component({
  tag: 'preview-markdown',
})
export class Markdown {
  @Element() el: HTMLPreviewMarkdownElement
  /** The markdown to be rendered */
  @Prop({ mutable: true }) source: string
  @Prop() small = false
  @State() formattedSource: string

  componentWillLoad() {
    this.source = this.source || this.el.textContent
  }

  render() {
    if (!this.source) {
      return null
    }
    const html = Marked.parse(unindent(this.source))
    return <ui-content src={html} small={this.small} />
  }
}
